(function () {
  'use strict';
  var SG_EN = /^en\b/i.test(document.documentElement.lang || '');

  var backdrop = document.getElementById('ebook-popup-backdrop');
  if (!backdrop) return;

  var checkbox = document.getElementById('ebook-popup-checkbox');
  var confirmBtn = document.getElementById('ebook-popup-confirm');
  var closeBtn = document.getElementById('ebook-popup-close');
  var closeTimeoutId = null;

  var variantIds = new Set();
  try {
    var raw = JSON.parse(backdrop.getAttribute('data-variant-ids') || '[]');
    raw.forEach(function (id) {
      if (id != null && String(id).trim() !== '') variantIds.add(String(id).trim());
    });
  } catch (e) {}

  /* תואם theme.liquid - אם data-variant-ids חלקי/לא מסונכרן עם הקטלוג */
  var sgVid = window.__SG_EBOOK_V_ID;
  if (sgVid != null && String(sgVid).trim() !== '') {
    variantIds.add(String(sgVid).trim());
  }

  if (!variantIds.size) return;

  var originalFetch = window.fetch;
  var pendingResolve = null;
  /** אחרי אישור פופאפ - fetch אחד עוקף את בדיקת הספר (מונע לולאה עם יירוט submit) */
  var sgEbookPassOneFetch = false;

  /* ── Duplicate add prevention: ebook is a digital product (max qty 1) ── */

  var SG_EBOOK_PRODUCT_ID = 8502297919671;

  /**
   * Fetches /cart.js and returns the existing ebook line item, or null if absent.
   * Uses originalFetch to bypass our own interceptor.
   */
  function findEbookLineInCart() {
    return originalFetch.call(window, '/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var items = (cart && cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        if (items[i].product_id === SG_EBOOK_PRODUCT_ID) return items[i];
      }
      return null;
    })
    .catch(function () { return null; });
  }

  /** 422 response returned when a duplicate ebook add is blocked. */
  function ebookDuplicateBlockResponse() {
    return new Response(
      JSON.stringify({ status: 422, message: 'duplicate', description: SG_EN ? 'The guide is already in your cart' : 'הספר כבר נמצא בעגלה שלך' }),
      { status: 422, headers: { 'Content-Type': 'application/json' } }
    );
  }

  /** Brief RTL toast shown when a duplicate ebook add is blocked. */
  function showEbookAlreadyInCartToast() {
    var existing = document.getElementById('sg-ebook-dup-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.id = 'sg-ebook-dup-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.style.cssText = [
      'position:fixed',
      'bottom:24px',
      'right:50%',
      'transform:translateX(50%)',
      'background:#1A2530',
      'color:#fff',
      'font-family:var(--text-font-family)',
      'font-size:14px',
      'font-weight:600',
      SG_EN ? 'direction:ltr' : 'direction:rtl',
      'padding:12px 20px',
      'border-radius:12px',
      'box-shadow:0 4px 20px rgba(0,0,0,0.18)',
      'z-index:2147483647',
      'opacity:0',
      'transition:opacity 0.25s ease',
      'white-space:nowrap',
      'pointer-events:none'
    ].join(';');
    toast.textContent = SG_EN ? '\u2713 The guide is already in your cart' : '\u2713 \u05d4\u05e1\u05e4\u05e8 \u05db\u05d1\u05e8 \u05e0\u05de\u05e6\u05d0 \u05d1\u05e2\u05d2\u05dc\u05d4 \u05e9\u05dc\u05da';
    document.body.appendChild(toast);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { toast.style.opacity = '1'; });
    });
    setTimeout(function () {
      toast.style.opacity = '0';
      setTimeout(function () { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 280);
    }, 3000);

    /* Open the cart drawer so the customer can see the ebook already there */
    setTimeout(function () {
      if (window.themeVariables && window.themeVariables.settings.cartType === 'drawer') {
        var cartDrawer = document.getElementById('cart-drawer');
        if (cartDrawer && cartDrawer.show) cartDrawer.show();
      }
    }, 300);
  }

  /* ── Firestore: ebook consent (fire-and-forget; never blocks cart) ── */

  function logEbookConsentConfirmed() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var ebookVariantId = String((window.__SG_EBOOK_V_ID != null ? window.__SG_EBOOK_V_ID : '47170737471671'));
    var bundlePIds = window.__SG_BUNDLE_P_IDS;
    if (!Array.isArray(bundlePIds)) bundlePIds = [];

    var tries = 0;
    function tryWhenFirestoreReady() {
      var db = window.db;
      var h = window.firestoreHelpers;
      if (!db || !h || typeof h.collection !== 'function' || typeof h.addDoc !== 'function') {
        if (++tries < 80) setTimeout(tryWhenFirestoreReady, 50);
        return;
      }

      function basePayload(cart_token, bundle_status) {
        return {
          action: 'consent_confirmed',
          variant_id: ebookVariantId,
          cart_token: cart_token || '',
          bundle_status: !!bundle_status,
          timestamp: typeof h.serverTimestamp === 'function' ? h.serverTimestamp() : new Date().toISOString()
        };
      }

      var payloadPromise = originalFetch.call(window, root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var bundleSet = {};
          for (var i = 0; i < bundlePIds.length; i++) {
            bundleSet[String(bundlePIds[i])] = true;
          }
          var seen = {};
          var items = cart && cart.items;
          if (items && items.length) {
            for (var j = 0; j < items.length; j++) {
              var pid = items[j] && items[j].product_id != null ? String(items[j].product_id) : '';
              if (pid && bundleSet[pid]) seen[pid] = true;
            }
          }
          var bundle_status = Object.keys(seen).length >= 5;
          var cart_token = (cart && cart.token) ? String(cart.token) : '';
          return basePayload(cart_token, bundle_status);
        })
        .catch(function () {
          return basePayload('', false);
        });

      payloadPromise
        .then(function (payload) {
          return h.addDoc(h.collection(db, 'ebook_consent_logs'), payload);
        })
        .catch(function (err) {
          if (typeof console !== 'undefined' && console.warn) {
            console.warn('[ebook-popup] ebook_consent_logs write failed', err);
          }
        });
    }
    tryWhenFirestoreReady();
  }

  /* ── Pause / unpause open drawer focus traps so our popup doesn't close them ── */

  function pauseOpenTraps() {
    document.querySelectorAll('[open][aria-modal="true"]').forEach(function (el) {
      if (el._focusTrap && el._focusTrap.pause) el._focusTrap.pause();
    });
  }

  function unpauseOpenTraps() {
    document.querySelectorAll('[aria-modal="true"]').forEach(function (el) {
      if (el._focusTrap && el._focusTrap.unpause) el._focusTrap.unpause();
    });
  }

  /* ── Popup open / close ── */

  function openPopup(onConfirm, onDismiss) {
    if (closeTimeoutId) {
      clearTimeout(closeTimeoutId);
      closeTimeoutId = null;
    }
    pendingResolve = { confirmed: false, onDismiss: onDismiss || null };
    pauseOpenTraps();
    backdrop.classList.remove('is-closing');
    checkbox.checked = false;
    confirmBtn.disabled = true;
    confirmBtn.setAttribute('aria-disabled', 'true');
    backdrop.classList.add('is-open');
    confirmBtn.onclick = function () {
      logEbookConsentConfirmed();
      pendingResolve.confirmed = true;
      pendingResolve = null;
      closePopup();
      setTimeout(onConfirm, 300);
    };
  }

  function restoreAriaBusyButtons() {
    document.querySelectorAll('button[is="custom-button"][aria-busy="true"]').forEach(function (btn) {
      btn.removeAttribute('aria-busy');
    });
  }

  var suppressNextCartEvents = false;

  function suppressCartEventsOnce() {
    if (suppressNextCartEvents) return;
    suppressNextCartEvents = true;

    function blockVariantAdd(e) { e.stopImmediatePropagation(); }
    function blockCartChange(e) { e.stopImmediatePropagation(); }

    document.addEventListener('variant:add', blockVariantAdd, true);
    document.documentElement.addEventListener('cart:change', blockCartChange, true);

    setTimeout(function () {
      document.removeEventListener('variant:add', blockVariantAdd, true);
      document.documentElement.removeEventListener('cart:change', blockCartChange, true);
      suppressNextCartEvents = false;
    }, 2000);
  }

  function closePopup() {
    if (closeTimeoutId) return;
    var pending = pendingResolve;
    pendingResolve = null;
    backdrop.classList.remove('is-open');
    backdrop.classList.add('is-closing');
    closeTimeoutId = setTimeout(function () {
      backdrop.classList.remove('is-closing');
      unpauseOpenTraps();
      closeTimeoutId = null;
      if (pending && !pending.confirmed) {
        restoreAriaBusyButtons();
        suppressCartEventsOnce();
        if (pending.onDismiss) pending.onDismiss();
      }
    }, 250);
  }

  checkbox.addEventListener('change', function () {
    var ok = checkbox.checked;
    confirmBtn.disabled = !ok;
    confirmBtn.setAttribute('aria-disabled', ok ? 'false' : 'true');
  });

  closeBtn.addEventListener('click', closePopup);

  backdrop.addEventListener('click', function (e) {
    e.stopPropagation();
    if (e.target === backdrop) closePopup();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && backdrop.classList.contains('is-open') && !closeTimeoutId) closePopup();
  });

  /* ── Body inspection: does this cart/add request contain the ebook? ── */

  function isVariantIdFormKey(key) {
    var k = String(key);
    if (k === 'id' || k === 'variant_id') return true;
    return /^items\[[^\]]*\]\[id\]$/.test(k) || /^items\[[^\]]*\]\[variant_id\]$/.test(k);
  }

  function lineItemHasBypassPopup(item) {
    if (!item) return false;
    if (item._bypass_popup === true || String(item._bypass_popup) === 'true') return true;
    var p = item.properties;
    if (!p) return false;
    if (Array.isArray(p)) {
      for (var pi = 0; pi < p.length; pi++) {
        if (String(p[pi].name) !== '_bypass_popup') continue;
        var pv = p[pi].value;
        if (pv === true || String(pv) === 'true' || String(pv) === '1') return true;
      }
      return false;
    }
    var bp = p._bypass_popup;
    return bp === true || String(bp) === 'true' || bp === 1 || String(bp) === '1';
  }

  /**
   * FormData / URLSearchParams: סורקים את כל הזוגות key/value (לא רק get('id')) -
   * Safely שולח לעתים רק items[0][id] או מפתחות אחרים בלי שדה id ברמה העליונה.
   */
  function iterableContainsEbookLine(iterable) {
    var bypassPopup = false;
    var hasEbookVariant = false;
    if (!iterable || typeof iterable.forEach !== 'function') return false;
    iterable.forEach(function (value, key) {
      var k = String(key);
      var v = value == null ? '' : String(value).trim();
      if (k === '_bypass_popup' || k.indexOf('_bypass_popup') !== -1) {
        if (v === 'true' || v === '1') bypassPopup = true;
      }
      if (isVariantIdFormKey(k) && v && variantIds.has(v)) {
        hasEbookVariant = true;
      }
    });
    if (bypassPopup) return false;
    return hasEbookVariant;
  }

  /* Fallback: a product-form belongs to the ebook product even if its variant
     ids haven't been wired into `variantIds`. Lets us gate the popup purely
     from `data-product-id` so a stale/missing variant set can't silently skip
     the terms check and let the form submit natively to /cart/add. */
  function formBelongsToEbook(form) {
    if (!form || !form.dataset) return false;
    var pid = form.dataset.productId;
    return pid && String(pid).trim() === String(SG_EBOOK_PRODUCT_ID);
  }

  function isCartAddFormAction(action) {
    if (action == null) return false;
    return String(action).toLowerCase().indexOf('cart/add') !== -1;
  }

  function isCartAddFetchUrl(url) {
    if (url == null || typeof url !== 'string') return false;
    return url.toLowerCase().indexOf('cart/add') !== -1;
  }

  /**
   * Collection / upsell / quick-buy drawer: we cannot rely on a form-target
   * capture listener - Safely's ProductForm constructor attaches its own
   * submit listener first, and on the same target DOM listeners fire in
   * registration order regardless of the capture flag, so ProductForm's
   * fetch kicks off before we can stopImmediatePropagation.
   *
   * Binding on `document` in capture phase moves our handler into the true
   * capture traversal (root → target), which runs before any target-level
   * listener. preventDefault + stopImmediatePropagation here blocks both
   * the native submit and ProductForm's handler on the form itself.
   */
  function handleEbookSubmitCapture(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (form.getAttribute('is') !== 'product-form') return;

    if (form.dataset.sgEbookAllowProductSubmit === '1') {
      delete form.dataset.sgEbookAllowProductSubmit;
      return;
    }
    if (!isCartAddFormAction(form.getAttribute('action'))) return;

    var fd;
    try {
      fd = new FormData(form);
    } catch (err) {
      return;
    }
    if (!iterableContainsEbookLine(fd) && !formBelongsToEbook(form)) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    findEbookLineInCart().then(function (existingLine) {
      if (existingLine) {
        restoreAriaBusyButtons();
        showEbookAlreadyInCartToast();
        return;
      }
      openPopup(
        function () {
          sgEbookPassOneFetch = true;
          form.dataset.sgEbookAllowProductSubmit = '1';
          queueMicrotask(function () {
            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit();
            } else {
              form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            }
          });
        },
        function () {
          restoreAriaBusyButtons();
        }
      );
    });
  }

  document.addEventListener('submit', handleEbookSubmitCapture, true);

  function bodyContainsEbook(body) {
    if (!body) return false;

    if (body instanceof FormData) return iterableContainsEbookLine(body);
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      return iterableContainsEbookLine(body);
    }

    var obj = null;
    if (typeof body === 'string') {
      try {
        obj = JSON.parse(body);
      } catch (e) {
        if (typeof URLSearchParams !== 'undefined') {
          try {
            return iterableContainsEbookLine(new URLSearchParams(body));
          } catch (e2) {
            return false;
          }
        }
        return false;
      }
    } else if (typeof body === 'object') {
      obj = body;
    }

    if (obj) {
      if (String(obj._bypass_popup) === 'true' || obj._bypass_popup === true) return false;
      if (obj.items && Array.isArray(obj.items)) {
        for (var i = 0; i < obj.items.length; i++) {
          var it = obj.items[i];
          if (!it) continue;
          var vid =
            it.id != null
              ? String(it.id).trim()
              : it.variant_id != null
                ? String(it.variant_id).trim()
                : '';
          if (!vid || !variantIds.has(vid)) continue;
          if (lineItemHasBypassPopup(it)) continue;
          return true;
        }
      }
      if (obj.id != null && variantIds.has(String(obj.id).trim()) && !lineItemHasBypassPopup(obj)) {
        return true;
      }
    }

    return false;
  }

  function cloneBody(body) {
    if (body instanceof FormData) {
      var fd = new FormData();
      body.forEach(function (v, k) { fd.append(k, v); });
      return fd;
    }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      return new URLSearchParams(body.toString());
    }
    if (typeof body === 'object' && body !== null) {
      return JSON.parse(JSON.stringify(body));
    }
    return body;
  }

  function dismissCartAddResponse() {
    var description = SG_EN ? 'To add the guide to your cart, please accept the terms' : 'כדי להוסיף את הספר לעגלה צריך לאשר את התקנון';
    return new Response(JSON.stringify({ status: 422, message: 'aborted', description: description }), {
      status: 422,
      headers: { 'Content-Type': 'application/json' }
    });
  }

  function passthroughCartAddAfterTerms(input, init, bodyForPost) {
    init = init || {};
    var cloned = cloneBody(bodyForPost);
    if (input instanceof Request) {
      var req = input;
      var headers = new Headers(req.headers);
      if (cloned instanceof FormData) {
        headers.delete('content-type');
      }
      var reqOpts = {
        method: (req.method || 'POST').toUpperCase(),
        headers: headers,
        body: cloned,
        credentials: req.credentials,
        mode: req.mode,
        cache: req.cache,
        redirect: req.redirect,
        referrer: req.referrer,
        referrerPolicy: req.referrerPolicy,
        integrity: req.integrity
      };
      if (init.signal) reqOpts.signal = init.signal;
      return originalFetch.call(window, req.url, reqOpts);
    }
    var nextInit = Object.assign({}, init, { body: cloned });
    if (cloned instanceof FormData && nextInit.headers) {
      try {
        var h = new Headers(nextInit.headers);
        h.delete('content-type');
        nextInit.headers = h;
      } catch (e) {}
    }
    return originalFetch.call(window, input, nextInit);
  }

  /* ── Fetch interceptor ── */

  window.fetch = function (input, init) {
    init = init || {};

    if (sgEbookPassOneFetch) {
      sgEbookPassOneFetch = false;
      return originalFetch.apply(this, arguments);
    }

    var url = '';
    if (typeof input === 'string') url = input;
    else if (input && typeof input.url === 'string') url = input.url;
    else if (input && typeof input.href === 'string') url = input.href;
    else if (input && typeof input.toString === 'function') url = input.toString();

    if (!isCartAddFetchUrl(url)) {
      return originalFetch.call(window, input, init);
    }

    var method = 'GET';
    if (input instanceof Request) {
      method = (input.method || 'GET').toUpperCase();
    } else if (init.method) {
      method = String(init.method).toUpperCase();
    }
    if (method !== 'POST') {
      return originalFetch.call(window, input, init);
    }

    var body = (input instanceof Request) ? null : init.body;

    if (input instanceof Request) {
      var req = input.clone();
      var ct = (req.headers && req.headers.get('content-type')) || '';
      var bodyPromise = ct.indexOf('multipart/form-data') !== -1
        ? req.formData()
        : req.text().then(function (t) {
            try { return JSON.parse(t); } catch (e) { return t; }
          });

      return bodyPromise.then(function (resolvedBody) {
        if (!bodyContainsEbook(resolvedBody)) {
          return originalFetch.call(window, input, init);
        }
        return findEbookLineInCart().then(function (existingLine) {
          if (existingLine) {
            showEbookAlreadyInCartToast();
            return ebookDuplicateBlockResponse();
          }
          return new Promise(function (resolve, reject) {
            openPopup(
              function () {
                passthroughCartAddAfterTerms(input, init, resolvedBody)
                  .then(function (r) { resolve(r.clone()); })
                  .catch(reject);
              },
              function () {
                resolve(dismissCartAddResponse());
              }
            );
          });
        });
      }).catch(function () {
        return originalFetch.call(window, input, init);
      });
    }

    if (!bodyContainsEbook(body)) {
      return originalFetch.call(window, input, init);
    }

    return findEbookLineInCart().then(function (existingLine) {
      if (existingLine) {
        showEbookAlreadyInCartToast();
        return ebookDuplicateBlockResponse();
      }
      return new Promise(function (resolve, reject) {
        openPopup(
          function () {
            passthroughCartAddAfterTerms(input, init, body)
              .then(function (r) { resolve(r.clone()); })
              .catch(reject);
          },
          function () {
            resolve(dismissCartAddResponse());
          }
        );
      });
    });
  };

  /* ── XMLHttpRequest Interceptor ── */
  var originalXHROpen = window.XMLHttpRequest ? XMLHttpRequest.prototype.open : null;
  var originalXHRSend = window.XMLHttpRequest ? XMLHttpRequest.prototype.send : null;
  
  if (originalXHROpen && originalXHRSend) {
    XMLHttpRequest.prototype.open = function(method, url) {
      this._sg_url = (url || '').toString();
      return originalXHROpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function(body) {
      var url = this._sg_url || '';
      if (!isCartAddFetchUrl(url)) {
        return originalXHRSend.apply(this, arguments);
      }
      if (!bodyContainsEbook(body)) {
        return originalXHRSend.apply(this, arguments);
      }

      var xhr = this;
      findEbookLineInCart().then(function (existingLine) {
        if (existingLine) {
          showEbookAlreadyInCartToast();
        } else {
          openPopup(
            function () {
              var cloned = cloneBody(body);
              originalXHRSend.call(xhr, cloned);
            },
            function () {
              if (typeof xhr.abort === 'function') xhr.abort();
            }
          );
        }
      });
    };
  }

  window.ebookPopup = { open: openPopup };
})();
